import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledAlert } from './styles';

const StyledObject = styled.object`
  width: 100%;
  max-height: 50vh;
`;

function PDFDriver({ url }) {
  return (
    <StyledObject
      aria-label="document"
      type="application/pdf"
      data={url}
      onDrop={(e) => e.preventDefault()}
    >
      <StyledAlert severity="warning">
        Виникла помилка при створенні перегляду файлу
      </StyledAlert>

    </StyledObject>
  );
}

PDFDriver.propTypes = {
  url: PropTypes.string.isRequired,
};

export default PDFDriver;
